import {toggleModal} from "./toggleModalActions";
import {
    addDrainStationSuccess, getDrainStations,
    getDrainStationsError,
    getDrainStationsPending,
    getDrainStationsSuccess
} from "./drainStationsActions";

export const getGateSwitchersPending = () => {
    return {
        type: 'GET_GATE_SWITCHERS_PENDING'
    }
};

export const getGateSwitchersSuccess = (gateSwitchers, page, pageCount, itemsCount) => {
    return {
        type: 'GET_GATE_SWITCHERS_SUCCESS',
        gateSwitchers,
        page,
        pageCount,
        itemsCount
    }
};

export const getGateSwitchersAlertRulesSuccess = (gateSwitchersAlertRules) => {
    return {
        type: 'GET_GATE_SWITCHERS_ALERT_RULES_SUCCESS',
        gateSwitchersAlertRules,
    }
};

export const getGateSwitchersError = error => {
    return {
        type: 'GET_GATE_SWITCHERS_ERROR',
        error: error
    }
};

export const addGateSwitcherSuccess = () => {
    return {
        type: 'ADD_GATE_SWITCHER_SUCCESS'
    }
};

export const selectGateSwitcher = (gateSwitcher, page) => {
    return {
        type: 'SELECT_GATE_SWITCHER',
        selected: { gateSwitcher: gateSwitcher, page }
    };
};

export const setGateSwitchersFilters = filters => {
    return {
        type: 'SET_GATE_SWITCHERS_FILTERS',
        filters: filters
    }
};

export const getGateSwitchers = (page, numberPerPage, search) => {
    const pageNumber = page ? page : 1;
    // const filterValue = filter ? filter : 'ALL';
    const searchParam = search ? `&search_query=${search}` : '';
    const numberOfRecords = numberPerPage ? numberPerPage : 3;

    return dispatch => {
        dispatch(getGateSwitchersPending());

        fetch(`${process.env.REACT_APP_API_URL}/gate_switchers/listGateSwitchControlSets?page=${pageNumber}&number_on_page=${numberOfRecords}${searchParam}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getGateSwitchersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getGateSwitchersSuccess(res.gateSwitchControlSets, res.page, res.pageCount, res.itemsCount))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getGateSwitchersAlertRules = () => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/alert_rules_for_gate_control`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getGateSwitchersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(
                    getGateSwitchersAlertRulesSuccess(
                        res.map(el => ({ ...el, value: el?.ruleName, label: el?.ruleName }))
                    )
                );
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const addGateSwitcher = data => {
    return dispatch => {
        dispatch(getGateSwitchersPending());

        fetch(`${process.env.REACT_APP_API_URL}/gate_switchers/addGateSwitchControlSet`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addGateSwitcherSuccess());
                    dispatch(getGateSwitchers(1))
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(getGateSwitchersError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const editGateSwitcher = (data) => {
    return dispatch => {
        dispatch(getGateSwitchersPending());

        fetch(`${process.env.REACT_APP_API_URL}/gate_switchers/updateGateSwitchControlSet`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getGateSwitchers(1))
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(getGateSwitchersError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}


export const deleteGateSwitcher = (id) => {
    return dispatch => {
        dispatch(getGateSwitchersPending());

        fetch(`${process.env.REACT_APP_API_URL}/gate_switchers/removeGateSwitchControlSet/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getGateSwitchers());
                } else {
                    dispatch(getGateSwitchersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
